import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const ATTRIBUTE_CREATE_RESOURCE = "app-role-attribute" as const;
export const ATTRIBUTE_CREATE_API_PATH = `/v1/${ATTRIBUTE_CREATE_RESOURCE}` as const;

export type AttributeCreateBody =
  paths[typeof ATTRIBUTE_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type AttributeCreateResponse =
  paths[typeof ATTRIBUTE_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useAttributeCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<AttributeCreateResponse, Error, AttributeCreateBody>({
    mutationFn: async (attribute: AttributeCreateBody) => {
      const response = await alphartisApiAxios.post<AttributeCreateResponse>(ATTRIBUTE_CREATE_API_PATH, attribute);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ATTRIBUTE_CREATE_RESOURCE],
      });
    },
  });
};
